import React from "react";
import { Assets, Colors, FontFamily, PrimaryButton } from "utils/imports.utils";
import { ButtonSize, ButtonTypes } from "utils/interface.utils";
import { STRINGS } from "constants/strings.constant";
import { PreviewPublishCardProps } from "interfaces/preview.interface";
import DownloadProjectImages from "components/download_project_images/download_project_images.component";
import "./preview_publish_card.component.scss";

// The right-hand card of the preview screen: publish the project, then take the files away for print and sharing.
const PreviewPublishCard = (props: PreviewPublishCardProps): React.ReactElement => {
    const { status, isPublishing, onPublish, isImagesDownloadEnabled, projectName, targetImages, arLink, onDownloadQr } = props;

    const isPublished = status === 'published';

    return (
        <aside className="preview_publish_card">
            <h2 className="preview_publish_card_title">
                {isPublished ? STRINGS.preview.publishedTitle : STRINGS.preview.publishTitle}
            </h2>
            <p className="preview_publish_card_description">
                {isPublished ? STRINGS.preview.publishedDescription : STRINGS.preview.publishDescription}
            </p>
            {status === 'draft' && (
                <div className="preview_publish_card_publish_button">
                    <PrimaryButton
                        text={STRINGS.preview.publishButton}
                        left_icon={Assets.btn_publish}
                        type={ButtonTypes.PRIMARY}
                        size={ButtonSize.LARGE}
                        fontFamily={FontFamily.semiBold}
                        iconSize={{ width: 18, height: 18 }}
                        onClick={onPublish}
                        activity={isPublishing}
                        disabled={isPublishing}
                    />
                </div>
            )}
            <div className="preview_publish_card_files">
                <h3 className="preview_publish_card_files_title">{STRINGS.preview.filesTitle}</h3>
                <p className="preview_publish_card_files_description">{STRINGS.preview.filesDescription}</p>
                <DownloadProjectImages
                    className="preview_publish_card_files_images"
                    isEnabled={isImagesDownloadEnabled}
                    isHintHidden={true}
                    projectName={projectName}
                    targetImages={targetImages}
                    arLink={arLink}
                />
                <div className="preview_publish_card_files_qr">
                    <PrimaryButton
                        text={STRINGS.preview.downloadQr}
                        left_icon={Assets.download}
                        type={ButtonTypes.OUTLINED}
                        size={ButtonSize.MEDIUM}
                        fontFamily={FontFamily.semiBold}
                        iconSize={{ width: 18, height: 18 }}
                        color={Colors.primaryTextColor}
                        style={{ border: `1.5px solid ${Colors.primaryTextColor}` }}
                        onClick={onDownloadQr}
                    />
                </div>
                {!isImagesDownloadEnabled && (
                    <p className="preview_publish_card_files_hint">
                        <img src={Assets.lock} alt={STRINGS.preview.lockIconAlt} />
                        {STRINGS.preview.filesLockedHint}
                    </p>
                )}
            </div>
        </aside>
    );
};

export default PreviewPublishCard;
